import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { uiActions } from "../state/UiReducer.js";
import { LogList } from "../util/getLog";

/**
 * @name LogModal
 * @class LogModal
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class LogModal extends ConnectedHTMLElement {
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    if (newState.ui.showLog.show !== oldState.ui.showLog.show) {
      this.render();
    }
  }

  registerElementEvents() {
    const player = this.state.ui.showLog.player;
    const closeBtn = this.querySelector("#close");

    closeBtn.addEventListener("click", () => {
      DispatchAction(uiActions.toggleLog, { show: false, player });
    });
  }

  render() {
    const player = this.state.ui.showLog.player;
    this.innerHTML = `<link href="/static/styles.css" rel="stylesheet" />
        <dialog class="z-50 ${player === "top" ? "rotate-180" : ""}" id="select-modal" ${this.state.ui.showLog.show === true ? "open" : ""}>
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Game log</h3>
            <ul id="base-list" class="[&_.base-color]:w-5 [&_.log-item]:min-h-[5px] [&_.log-item]:my-1 [&_.base]:border-b [&_.base]:border-[#111] [&_.base:first-child]:border-t [&_.base:first-child]:border-[#111]">
              ${LogList(this.state)}
            </ul>
            <div class="modal-action">
                <button id="close" class="btn w-full mt-2">Close</button>
            </div>
          </div>
        </dialog>
      </div>
        `;
    this.registerElementEvents();
  }

  connectedCallback() {
    this.render();
  }
}
